import { AbstractCollection } from '../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { Weddings } from '../../Weddings';
import type { Agent } from '../Agents';
import type { ISchedule } from './Schedules.types';

@Identifiable
@Timestampable
export class Schedule extends AbstractDocument<ISchedule> {
  readonly collections = {};

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}

export class Schedules extends AbstractCollection<Schedule, ISchedule> {
  static path = 'schedules';

  constructor(document: Agent) {
    super(document.collection(Schedules.path), Schedule);
  }

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}
